import React from "react"
import i18n from "../../../../i18n";
const squareStyle = {
    width: "100%",
    height: "auto",
    border: "3px dotted grey",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
};
export default function ReportSelling(data) {
    let arr = data.arr;
    return (
        <div className="card mb-12 mb-xl-8">
             <table id={"table"} className="table table-responsive table-bordered table-hover" style={{ borderBottom: '1px solid #eff2f5'}}>
                <thead>
                <tr className="table-header">
                    <th width={"3%"} className="text-center">{i18n.t("No.")}</th>
                    <th width={"10%"} >{i18n.t("Branch")}</th>
                    <th width={"10%"} >{i18n.t("Type Customer")}</th>
                    <th width={"14%"} >{i18n.t("Item Code")}</th>
                    <th width={"10%"} >{i18n.t("Item Brand")}</th>
                    <th width={"10%"} >{i18n.t("Item Category")}</th>
                    <th width={"15%"} >{i18n.t("Item Name")}</th>
                    <th width={"8%"} >{i18n.t("Unit Name")}</th>
                    <th width={"10%"} >{i18n.t("Selling Price")}</th>
                    <th width={"10%"} >{i18n.t("Effective Date")}</th>
                </tr>
                </thead>
                <tbody key={"body"}>
                    {renderList(arr)}
                </tbody>
            </table>
        </div>
    )

    function renderList(data) {
        let html = [];
        let no = 1;
        if(data.length > 0){
            for(var i=0; i<data.length; i++){
                let type = data[i].type
                if(type!=null){
                    for(var s=0; s<type.length;s++){
                        let col = type[s].item
                        if(col != null){
                            for(var p=0; p<col.length; p++){
                                html.push(  
                                    <tr>
                                        <td style={{textAlign:'center'}}>
                                            {no}
                                        </td>
                                        <td style={{textAlign:'left', fontWeight:'bold'}}>
                                            {data[i].name}
                                        </td>
                                         <td>
                                            {type[s].name}
                                        </td>
                                        <td>
                                            {col[p].code}
                                        </td>
                                        <td>
                                            {col[p].brand}
                                        </td>
                                        <td>
                                            {col[p].category}
                                        </td>
                                        <td>
                                            {col[p].name_item}
                                        </td>
                                        <td>
                                            {col[p].unit}
                                        </td>
                                        <td style={{textAlign:'right'}}>
                                            {col[p].price_format}
                                        </td>
                                        <td style={{textAlign:'left'}}>
                                            {col[p].date}
                                        </td>
                                    </tr>
                                );
                                no++;
                            }
                        }
                    }
                    
                }
                
               
            }
        }
        return html;
    }
}






